import(/* webpackMode: "eager", webpackExports: ["QuizOnlineView"] */ "/web/src/sections/sub-pages/lms/quiz-online/view/quiz-online-view.tsx");
